
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const Audience = {
  ALL_STATIONS: 'ALL_STATIONS',
  KIDS: 'KIDS',
  LOCAL: 'LOCAL',
  NATIONAL: 'NATIONAL'
} as const

export type Audience = (typeof Audience)[keyof typeof Audience]


export const AvailabilityType = {
  PUBLIC: 'PUBLIC',
  ALL_MEMBERS: 'ALL_MEMBERS',
  STATION_MEMBERS: 'STATION_MEMBERS'
} as const

export type AvailabilityType = (typeof AvailabilityType)[keyof typeof AvailabilityType]


export const CollectionType = {
  KEYWORD: 'KEYWORD',
  CONTINUE_WATCHING: 'CONTINUE_WATCHING',
  LIVESTREAMS: 'LIVESTREAMS',
  MANUAL: 'MANUAL',
  MY_LIST: 'MY_LIST',
  PROMO: 'PROMO',
  RECOMMENDED_SHOWS: 'RECOMMENDED_SHOWS',
  TRENDING: 'TRENDING'
} as const

export type CollectionType = (typeof CollectionType)[keyof typeof CollectionType]


export const CollectionSortOrder = {
  ALPHABETICAL: 'ALPHABETICAL',
  EXPIRATION: 'EXPIRATION',
  MANUAL: 'MANUAL',
  NEWEST: 'NEWEST',
  RECOMMENDED: 'RECOMMENDED'
} as const

export type CollectionSortOrder = (typeof CollectionSortOrder)[keyof typeof CollectionSortOrder]


export const ContentDescriptor = {
  D: 'D',
  FV: 'FV',
  L: 'L',
  S: 'S',
  V: 'V'
} as const

export type ContentDescriptor = (typeof ContentDescriptor)[keyof typeof ContentDescriptor]


export const ContentRating = {
  TVY: 'TVY',
  TVY7: 'TVY7',
  TVG: 'TVG',
  TVPG: 'TVPG',
  TV14: 'TV14',
  TVMA: 'TVMA',
  NR: 'NR'
} as const

export type ContentRating = (typeof ContentRating)[keyof typeof ContentRating]


export const ContentSubType = {
  CLIP: 'CLIP',
  EPISODE: 'EPISODE',
  EPISODIC_SERIES: 'EPISODIC_SERIES',
  MOVIE: 'MOVIE',
  NEWS: 'NEWS',
  NON_EPISODIC_SERIES: 'NON_EPISODIC_SERIES',
  PREVIEW: 'PREVIEW',
  SPECIAL: 'SPECIAL'
} as const

export type ContentSubType = (typeof ContentSubType)[keyof typeof ContentSubType]


export const ContentType = {
  AUDIOSTREAM: 'AUDIOSTREAM',
  LIVESTREAM: 'LIVESTREAM',
  PROMO: 'PROMO',
  SHOW: 'SHOW',
  VIDEO: 'VIDEO'
} as const

export type ContentType = (typeof ContentType)[keyof typeof ContentType]


export const DeviceType = {
  ANDROID: 'ANDROID',
  FIRETV: 'FIRETV',
  GOOGLETV: 'GOOGLETV',
  IOS: 'IOS',
  LGTV: 'LGTV',
  ROKU: 'ROKU',
  SAMSUNGTV: 'SAMSUNGTV',
  SMARTTV: 'SMARTTV',
  TVOS: 'TVOS',
  WEB: 'WEB'
} as const

export type DeviceType = (typeof DeviceType)[keyof typeof DeviceType]


export const EndUserCohort = {
  MEMBER: 'MEMBER',
  PROSPECT: 'PROSPECT'
} as const

export type EndUserCohort = (typeof EndUserCohort)[keyof typeof EndUserCohort]


export const EpisodesSortOrder = {
  EARLIEST: 'EARLIEST',
  EARLIEST_FROM_LATEST_SEASON: 'EARLIEST_FROM_LATEST_SEASON',
  LATEST: 'LATEST'
} as const

export type EpisodesSortOrder = (typeof EpisodesSortOrder)[keyof typeof EpisodesSortOrder]


export const GenreVibeType = {
  GENRE: 'GENRE',
  PBS_GENRE: 'PBS_GENRE',
  VIBE: 'VIBE'
} as const

export type GenreVibeType = (typeof GenreVibeType)[keyof typeof GenreVibeType]


export const LikeType = {
  LIKE: 'LIKE',
  DISLIKE: 'DISLIKE'
} as const

export type LikeType = (typeof LikeType)[keyof typeof LikeType]


export const MembershipTier = {
  NONE: 'NONE',
  PASSPORT: 'PASSPORT'
} as const

export type MembershipTier = (typeof MembershipTier)[keyof typeof MembershipTier]


export const PassportLevel = {
  ALL: 'ALL',
  NONE: 'NONE',
  SOME: 'SOME'
} as const

export type PassportLevel = (typeof PassportLevel)[keyof typeof PassportLevel]


export const PbsAccountClientType = {
  PRIVATE: 'PRIVATE',
  PUBLIC: 'PUBLIC'
} as const

export type PbsAccountClientType = (typeof PbsAccountClientType)[keyof typeof PbsAccountClientType]


export const PlatformType = {
  MOBILE: 'MOBILE',
  OTT: 'OTT',
  WEB: 'WEB'
} as const

export type PlatformType = (typeof PlatformType)[keyof typeof PlatformType]


export const PosterSize = {
  PORTRAIT_MEDIUM: 'PORTRAIT_MEDIUM',
  PORTRAIT_SMALL: 'PORTRAIT_SMALL',
  LANDSCAPE_MEDIUM: 'LANDSCAPE_MEDIUM',
  LANDSCAPE_SMALL: 'LANDSCAPE_SMALL'
} as const

export type PosterSize = (typeof PosterSize)[keyof typeof PosterSize]


export const PromoDestinationType = {
  PASSPORT_PROMO: 'PASSPORT_PROMO',
  SHOW: 'SHOW'
} as const

export type PromoDestinationType = (typeof PromoDestinationType)[keyof typeof PromoDestinationType]


export const ShowType = {
  EPISODIC_SERIES: 'EPISODIC_SERIES',
  MOVIE: 'MOVIE',
  NEWS: 'NEWS',
  NON_EPISODIC_SERIES: 'NON_EPISODIC_SERIES'
} as const

export type ShowType = (typeof ShowType)[keyof typeof ShowType]


export const StreamMediaType = {
  AUDIO: 'AUDIO',
  VIDEO: 'VIDEO'
} as const

export type StreamMediaType = (typeof StreamMediaType)[keyof typeof StreamMediaType]


export const StreamScheduleSourceType = {
  MAPPING: 'MAPPING',
  PBS_TVSS: 'PBS_TVSS',
  XMLTV: 'XMLTV'
} as const

export type StreamScheduleSourceType = (typeof StreamScheduleSourceType)[keyof typeof StreamScheduleSourceType]


export const UserRole = {
  ADMIN: 'ADMIN',
  GLOBAL_GM: 'GLOBAL_GM',
  GLOBAL_MARKETER: 'GLOBAL_MARKETER',
  GLOBAL_PROGRAMMER: 'GLOBAL_PROGRAMMER',
  STATION_GM: 'STATION_GM',
  STATION_MARKETER: 'STATION_MARKETER',
  STATION_PROGRAMMER: 'STATION_PROGRAMMER'
} as const

export type UserRole = (typeof UserRole)[keyof typeof UserRole]


export const VideoType = {
  EPISODE: 'EPISODE',
  SPECIAL: 'SPECIAL',
  PREVIEW: 'PREVIEW',
  CLIP: 'CLIP'
} as const

export type VideoType = (typeof VideoType)[keyof typeof VideoType]
